import { render } from "./StagesView.vue?vue&type=template&id=ae1aaade&scoped=true"
import script from "./StagesView.vue?vue&type=script&lang=js"
export * from "./StagesView.vue?vue&type=script&lang=js"

import "./StagesView.vue?vue&type=style&index=0&id=ae1aaade&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae1aaade"]])

export default __exports__